<!-- Overlay con desenfoque -->
<div class="fixed inset-0 z-[100] bg-[#1a2e35]/30 backdrop-blur-sm flex items-center justify-center p-0 md:p-10 transition-all">
  
  <!-- Contenedor Modal con bordes redondeados -->
  <div class="w-full h-full md:max-w-6xl md:max-h-[85vh] bg-white md:rounded-2xl flex flex-col overflow-hidden shadow-2xl animate-fade-in relative">
    
    <!-- Header Centrado con Componente del Sistema -->
    <div class="pt-safe bg-white border-b border-gray-50">
      
      <!-- Banner de confirmación local -->
      @if (showSuccess) {
        <div class="bg-emerald-50 border-b border-emerald-100 py-3 px-4 flex items-center justify-center animate-fade-in-down">
          <span class="text-emerald-800 text-sm font-medium flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-emerald-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
            {{ '::ItemAdded' | abpLocalization }}
          </span>
        </div>
      }

      <div class="pt-6 pb-2 px-2 sm:px-4 flex flex-col items-center max-w-6xl mx-auto">
        
        <!-- Fila superior: Título y Cerrar -->
        <div class="w-full h-10 flex items-center justify-center relative mb-2 px-4">
          <h3 class="text-2xl font-bold text-[#1a2e35]">{{ '::Wines' | abpLocalization }}</h3>
          <button (click)="close()" class="absolute right-4 inset-y-0 flex items-center justify-center w-10 h-10 text-gray-300 hover:text-gray-900 transition-all -translate-y-1">
            <span class="text-3xl leading-none">&times;</span>
          </button>
        </div>

        <!-- Buscador Oficial del Sistema -->
        <div class="w-full">
          <app-metro-search-input [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)" [placeholder]="'::SearchWinesOrWineries' | abpLocalization" size="md">
          </app-metro-search-input>
          @if (clientName) {
            <p class="text-[11px] italic text-gray-400 -mt-1.5 px-1">
              Añadiendo vinos al carrito de {{ clientName }}
            </p>
          }
        </div>
      </div>
    </div>

    <!-- Listado de Vinos Estilo Catálogo Horizontal -->
    <div class="flex-1 overflow-y-auto pt-0 p-2 sm:pt-2 sm:px-4 sm:pb-4 bg-white" (scroll)="onScroll($event)">
      
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 max-w-6xl mx-auto pb-4">
        @for (wine of filteredWines; track wine.id) {
        <app-metro-product-card
          [id]="wine.id"
          [name]="getWineDisplayData(wine).name"
          [year]="getWineDisplayData(wine).year"
          [stock]="getWineDisplayData(wine).stock"
          [maxOrder]="getWineDisplayData(wine).maxOrder"
          [location]="getWineDisplayData(wine).location"
          [price]="getWineDisplayData(wine).price"
          [imageUrl]="getWineDisplayData(wine).imageUrl"
          [customUserId]="userId"
          [disableDetailsNavigation]="true"
          (cardClick)="openDetails($event)">
        </app-metro-product-card>
        }
      </div>

      <!-- Loading State (Initial or Pagination) -->
      @if (loading) {
        <div class="flex flex-col items-center justify-center py-10">
          <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-metro-blue"></div>
          @if (wines.length === 0) {
            <p class="mt-4 text-gray-400 font-medium text-sm">{{ '::Loading' | abpLocalization }}...</p>
          }
        </div>
      }

      @if (!loading && filteredWines.length === 0) {
        <div class="flex flex-col items-center justify-center py-20 text-center">
          <span class="text-5xl mb-4">🍷</span>
          <h4 class="text-xl font-bold text-gray-900">{{ '::NoWinesFound' | abpLocalization }}</h4>
          <p class="text-gray-400">{{ '::TryAnotherName' | abpLocalization }}</p>
        </div>
      }
    </div>

    <!-- Pop-up de Detalles (Nuevo Componente) -->
    @if (showDetails) {
      <app-assisted-wine-details
        [wineId]="selectedWineId"
        [userId]="userId"
        [sommelierSlug]="sommelierSlug"
        (closed)="closeDetails()">
      </app-assisted-wine-details>
    }
  </div>
</div>